import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostSchema } from './schemas';
import { jobPostQueryOptions } from './useJobPost';

export const useUpdateJobPostStatus = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (action: 'cancel' | 'fill') => {
      const { data: jobPost } = await fetchJson(`/job-posts/${id}/${action}`, {
        method: 'POST',
        schema: apiResourceSchema(jobPostSchema),
      });

      return jobPost;
    },
    onSuccess: (jobPost) => {
      queryClient.setQueryData(jobPostQueryOptions(jobPost.id).queryKey, jobPost);
      queryClient.invalidateQueries({ queryKey: QueryKeys.jobPosts.index.root });
    },
  });
};
